import { RouteFactory } from "@app/routePaths";
import { AwardsMenu } from "@events-awards/utils/types";
import { TabItem } from "@hooks/useTabs";
import { sectionNavigationItems } from "@util/constant";

export const EVENTS_AWARDS_SIA_PATH = RouteFactory.section(
  "events-awards/sustainability-impact-awards"
);
export const EVENTS_AWARDS_SIA_SLOT = EVENTS_AWARDS_SIA_PATH.replace("/", "");

export const EVENTS_AWARDS_SIA_LABEL =
  sectionNavigationItems[EVENTS_AWARDS_SIA_SLOT]?.label;

export const SIA_FOOTER_MENU = [
  {
    label: "About",
    link: RouteFactory.siaAboutPage,
  },
  {
    label: "Awards",
    link: RouteFactory.siaAwardsPage,
  },
  {
    label: "Winners",
    link: RouteFactory.eventsAwardsWinners("sustainability-impact-awards"),
  },
  {
    label: "News",
    link: RouteFactory.eventsAwardsNews("sustainability-impact-awards"),
  },
  {
    label: "How to Nominate",
    link: RouteFactory.siaNominatePage,
  },
  {
    label: "Contact Us",
    link: RouteFactory.siaContactUsPage,
  },
  {
    label: "Partners",
    link: RouteFactory.siaPartnersPage,
  },
  {
    label: "Judges",
    link: RouteFactory.siaJudgesPage,
  },
];

export const SIA_NAVIGATION_ITEMS: AwardsMenu[] = [
  {
    text: "About",
    link: RouteFactory.siaAboutPage,
    enabled: true,
  },
  {
    text: "Awards",
    link: RouteFactory.siaAwardsPage,
    enabled: true,
  },
  {
    text: "Winners",
    link: RouteFactory.eventsAwardsWinners("sustainability-impact-awards"),
    enabled: true,
  },
  {
    text: "News",
    link: RouteFactory.eventsAwardsNews("sustainability-impact-awards"),
    enabled: true,
  },
  {
    text: "Gallery",
    link: RouteFactory.eventsAwardsGallery("sustainability-impact-awards"),
    enabled: true,
  },
  {
    text: "How to Nominate",
    link: RouteFactory.siaNominatePage,
    enabled: true,
  },
];

export const NOMINATIONS_TAB: TabItem[] = [
  {
    key: "nominationsTab",
    label: "Nominations",
  },
  {
    key: "assessmentTab",
    label: "Assessment",
  },
  {
    key: "declarationsTab",
    label: "Declarations",
  },
];
